import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="py-10 space-y-2 text-center text-sm border-t">
        <p>
          Copyright © 2025{" "}
          <Link to="/" className="hover:underline">
            Nguyen Thanh Sang
          </Link>
        </p>
        <p>
          Thank you
          <Link
            to="https://nextjs.org/"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
          >
            {" "}
            React.js
          </Link>
          <Link
            to="https://motion.dev/"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
          >
            {" "}
            Framer Motion
          </Link>
          ,
          <Link
            to="https://ui.shadcn.com/"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
          >
            {" "}
            Shadcn UI
          </Link>
          ,
          <Link
            to="https://magicui.design/"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
          >
            {" "}
            Magic UI
          </Link>
          ,
          <Link
            to="https://ui.aceternity.com/"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
          >
            {" "}
            Aceternity UI
          </Link>{" "}
          help me to build this website
        </p>
        <div className="flex items-center justify-center">
          <Link
            to="https://react.dev/"
            target="_blank"
            rel="noreferrer"
            title="ReactJS"
            className="mr-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="22 22 1530 499.976"
              className="w-15 fill-foreground"
            >
              &gt;
              <path d="m 417.7,22 c -0.6,0 -1.2,0 -1.8,0 -9.8,0.2 -20.2,2.54 -30.8,6.46 -21.3,7.82 -44.4,22.33 -67.9,42.79 -4.6,4.01 -9.3,8.31 -14,12.81 -3.1,-3 -6.2,-5.8 -9.3,-8.6 C 269,53.38 244.5,37.85 222.1,29.48 210.9,25.3 200,22.79 189.8,22.55 c -10.2,-0.25 -19.7,1.75 -28,6.59 -16.2,9.33 -25,27.71 -28.8,50.02 -3.9,22.44 -2.9,49.64 3.1,80.24 1.2,6.1 2.6,12.3 4.2,18.7 -7.2,2 -14.2,4.2 -20.8,6.5 C 90.37,194.7 66.81,207.5 49.89,221.9 32.97,236.4 22,253.2 22,271.5 c 0,18.9 11.53,36.4 29.36,51.6 17.83,15.3 42.71,28.9 73.44,39.3 4.9,1.7 9.9,3.3 15.1,4.8 -1.7,6.8 -3.2,13.5 -4.4,20 -5.7,30.3 -6.4,57.1 -2.4,79 4.1,21.9 13.2,39.8 29.1,48.9 16.3,9.5 37.2,8.2 59.4,0.4 22.1,-7.8 46.2,-22.6 70.6,-44 3.9,-3.4 7.8,-7 11.7,-10.8 5.1,4.9 10.2,9.6 15.3,13.9 23.3,20.1 46.1,34.1 67.1,41.5 21,7.4 41.1,8.5 56.9,-0.7 16.4,-9.5 25.7,-28.2 30,-51.3 4.3,-23.1 3.5,-51.4 -2.8,-83.2 -1,-4.9 -2.1,-10 -3.3,-15 3.5,-1.1 7,-2.2 10.4,-3.3 31.6,-10.4 57.3,-23.8 75.8,-39 18.5,-15.2 30.5,-32.8 30.5,-52.1 0,-18.6 -11.5,-35.4 -28.9,-50 -17.4,-14.5 -41.5,-27.3 -71,-37.4 -5.8,-2 -11.8,-3.9 -18,-5.7 1,-4.1 2,-8.2 2.8,-12.3 6.7,-32.6 7.9,-61.6 4,-85.23 C 468.7,57.25 459.5,38.05 442.8,28.41 435.3,24.05 426.7,22.07 417.7,22 Z M 416,46.15 c 6.3,-0.16 11.3,1 14.8,3.05 7.6,4.35 14.9,16.05 18.2,35.57 3.3,19.63 2.4,46.03 -3.9,76.43 -0.8,3.7 -1.6,7.4 -2.5,11.2 -23.2,-5.4 -48.5,-9.4 -75.1,-11.9 -15.3,-21.8 -31.3,-41.8 -47.5,-59.3 4.4,-4.13 8.6,-8.13 12.9,-11.83 21.9,-19.01 43,-31.96 60.5,-38.38 8.7,-3.21 16.3,-4.68 22.6,-4.84 z M 187.2,46.7 c 0.7,0 1.6,0 2.4,0 6.7,0.19 14.8,1.8 24.1,5.26 18.6,6.94 41.1,20.9 64.2,41.5 2.8,2.5 5.6,5.1 8.4,7.84 -16.2,17.4 -32.3,37.3 -47.8,59.1 -26.5,2.5 -51.8,6.5 -74.9,11.7 -1.5,-5.9 -2.8,-11.7 -3.9,-17.3 -5.6,-28.4 -6.2,-53.2 -3.1,-71.54 3.2,-18.33 10.1,-29.23 17.2,-33.35 3.3,-1.91 7.8,-3.08 13.4,-3.22 z m 116,71.8 c 11.1,11.9 22.1,25.3 33,39.8 -10.9,-0.5 -22.1,-0.8 -33.3,-0.8 -11.1,0 -22.1,0.3 -33,0.8 11,-14.5 22.2,-27.8 33.3,-39.8 z m 454,23.8 0,229.2 28.6,0 0,-91.1 45.7,0 58.4,91.1 33.7,0 -61.9,-93.5 c 31.3,-2.8 59.5,-25.4 59.5,-66.7 0,-42.2 -29.9,-69 -71.9,-69 l -92.1,0 z m 726.8,17.8 0,45.4 -27,0 0,22.7 27,0 0,108.6 c 0,24.7 13,38.8 37,38.8 15,0 25,-4.5 31,-10.7 l -8,-19.2 c -3,3.8 -10,6.9 -17,6.9 -11,0 -17,-9 -17,-21.3 l 0,-103.1 34,0 0,-22.7 -34,0 0,-45.4 -26,0 z m -698.2,7.6 60.1,0 c 27.1,0 45.7,17.9 45.7,43.6 0,25.8 -18.6,44 -45.7,44 l -60.1,0 0,-87.6 z m -482.9,13.8 c 17.5,0 34.6,0.7 51.2,1.9 9.4,13.8 18.5,28.3 27.2,43.3 8.7,15 16.8,30.1 24.1,45 -7.3,15.1 -15.3,30.4 -24.1,45.5 -8.7,15.1 -17.7,29.6 -27,43.5 -16.7,1.2 -33.9,1.8 -51.4,1.8 -17.3,0 -34.3,-0.6 -50.9,-1.6 -9.4,-13.9 -18.6,-28.4 -27.4,-43.5 -8.8,-15.1 -16.8,-30.3 -24,-45.3 7.2,-15.1 15.2,-30.2 23.9,-45.3 8.7,-15.1 17.9,-29.6 27.3,-43.4 16.6,-1.2 33.7,-1.9 51.1,-1.9 z m -82,5 c -5.9,9.2 -11.6,18.6 -17.2,28.3 -5.6,9.7 -10.8,19.4 -15.8,29 -7.1,-16.6 -13,-32.9 -17.9,-48.5 16,-3.6 33,-6.5 50.9,-8.8 z m 164,0.1 c 18,2.2 35.2,5.3 51.2,8.9 -4.8,15.6 -10.9,31.8 -18,48.4 -5.1,-9.7 -10.5,-19.5 -16.1,-29.2 -5.6,-9.6 -11.3,-19 -17.1,-28.1 z m -238.2,14.6 c 7,22.7 16.2,46.6 27.4,70.9 -11.4,24.7 -20.7,48.9 -27.8,71.9 -4.7,-1.3 -9.3,-2.8 -13.8,-4.3 C 104.1,330 81.68,317.5 66.97,304.9 52.25,292.3 46,280.1 46,271.5 c 0,-8.3 5.71,-19.5 19.49,-31.3 13.77,-11.8 34.91,-23.6 61.91,-33 6.1,-2.1 12.6,-4.1 19.3,-6 z m 876.3,0.2 c -47.5,0 -81.9,38.8 -81.9,86.9 0,51.9 35.4,87.3 83.9,87.3 27,0 50,-8.9 66,-25.4 l -12,-16.9 c -13,13.4 -32,21 -51,21 -35.7,0 -57.7,-26.1 -59.7,-57.4 l 133.7,0 0,-6.5 c 0,-49.9 -29,-89 -79,-89 z m 178,0 c -27,0 -48,8.9 -66,27.5 l 12,17.8 c 15,-15.8 31,-23 51,-23 24,0 42,12.7 42,35.1 l 0,29.9 c -14,-15.5 -33,-22.7 -55,-22.7 -28,0 -58,17.5 -58,54.6 0,36.1 30,55 58,55 22,0 41,-7.9 55,-23 l 0,18.9 25,0 0,-114.1 c 0,-40.2 -29,-56 -64,-56 z m 184,0 c -49,0 -83,37.8 -83,86.9 0,49.5 34,87.3 83,87.3 30,0 48,-12.4 61,-28.9 l -17,-15.8 c -11,14.8 -25,21.7 -42,21.7 -36,0 -58,-27.5 -58,-64.3 0,-36.8 22,-63.9 58,-63.9 17,0 31,6.5 42,21.6 l 17,-15.8 c -13,-16.5 -31,-28.8 -61,-28.8 z m -925.5,0.1 c 5.7,1.7 11.3,3.5 16.6,5.3 27.4,9.4 49.2,21.2 63.5,33.2 14.2,11.9 20.2,23.3 20.2,31.5 0,8.7 -6.4,20.9 -21.7,33.5 -15.4,12.6 -38.7,25.1 -68.1,34.9 -3.1,1 -6.2,2 -9.4,2.9 -7.2,-22.8 -16.9,-46.8 -28.5,-71.1 11.2,-24 20.4,-47.6 27.4,-70.2 z m -156.6,19.9 a 50.17,50.17 0 0 0 -50.1,50.1 50.17,50.17 0 0 0 50.1,50.2 50.17,50.17 0 0 0 50.2,-50.2 50.17,50.17 0 0 0 -50.2,-50.1 z m 719.1,1.3 c 38,0 54,30.6 55,55.3 l -108.7,0 c 1.3,-25.4 18.9,-55.3 53.7,-55.3 z m 172,61.8 c 18,0 36,6.9 46,20.6 l 0,31.3 c -10,13.8 -28,20.6 -46,20.6 -24,0 -41,-15.1 -41,-36 0,-21.4 17,-36.5 41,-36.5 z m -775.6,15 c 7.4,17 13.8,33.6 18.8,49.4 -16.3,3.7 -33.9,6.7 -52.3,8.9 5.8,-9.3 11.6,-18.9 17.2,-28.6 5.7,-9.9 11.1,-19.8 16.3,-29.7 z m -230.5,0.8 c 5,9.7 10.3,19.4 15.9,29.1 5.7,9.8 11.6,19.4 17.6,28.8 -18.2,-2 -35.6,-4.8 -51.7,-8.3 4.9,-15.9 11,-32.5 18.2,-49.6 z M 443.8,372 c 1.2,4.6 2.2,9.2 3.1,13.6 5.8,29.4 6.2,55.1 2.7,74.1 -3.5,19.1 -11,30.6 -18.4,34.9 -7.2,4.2 -19.8,4.9 -36.9,-1.1 -17.1,-6.1 -37.9,-18.5 -59.5,-37.1 -4.7,-4 -9.4,-8.3 -14.1,-12.9 16.1,-17.6 31.9,-37.8 47.1,-59.8 27,-2.4 52.6,-6.3 76,-11.7 z m -280.6,1.1 c 23.4,5.2 48.9,8.8 75.7,10.9 15.6,22 31.9,42.1 48.2,59.6 -3.6,3.5 -7.1,6.8 -10.7,9.9 -22.5,19.7 -44.6,32.9 -62.8,39.3 -18.3,6.5 -32,5.8 -39.4,1.5 -7.2,-4.1 -14.1,-14.7 -17.5,-32.5 -3.3,-17.8 -2.9,-42 2.4,-70.1 1.1,-6 2.5,-12.2 4.1,-18.6 z m 173.6,12.6 c -10.9,14.8 -21.9,28.4 -32.9,40.6 -11.3,-12.2 -22.7,-25.8 -33.8,-40.4 10.8,0.4 21.7,0.6 32.8,0.6 11.4,0 22.7,-0.3 33.9,-0.8 z" />
            </svg>
          </Link>
          <Link
            target="_blank"
            to="https://www.dmca.com/Protection/Status.aspx?ID=a78f2a86-54aa-4212-9008-e3360f10659c&refurl=https://shangdev.id.vn/"
            title="DMCA.com Protection Status"
            className="dmca-badge"
          >
            <img
              src="/assets/images/dmca_protected_sml_120l.png"
              alt="DMCA.com Protection Status"
            />
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
